import { Injectable } from '@angular/core';
import { User } from '../domain/users/user.model';
import { Publisher } from '../domain/publisher.model';
import { DemandPartner } from '../domain/demand-partner.model';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UserUtils } from '../domain/users/user-utils.model';

@Injectable()
export class Principal {
  userFromToken: User;
  public user: User;
  public publisher: Publisher;
  public demandPartner: DemandPartner;
  private authenticated: any;
  private accessToken: string;

  constructor() {
  }

  setToken(token: string) {
    try {
      this.userFromToken = new JwtHelperService().decodeToken(token);
      this.authenticated = token !== null;
    } catch (e) {
      console.error('user could not be extracted from token');
    }
    this.accessToken = token;
  }

  getToken() {
    return this.accessToken;
  }

  cleanup() {
    console.log('principal cleanup');
    this.userFromToken = null;
    this.user = null;
    this.publisher = null;
    this.accessToken = null;
    this.authenticated = false;
  }

  setUser(user: User) {
    this.user = user;
    UserUtils.unpack(this.user);
    console.log('setUser: %o', user);
  }

  setPublisher(publisher: Publisher) {
    this.publisher = publisher;
    this.publisher.pubDashRevShareDisabled = publisher.name === 'Sporcle'; // hardcoded, until we transfer it to backend
  }

  getPublisher() {
    return this.publisher;
  }

  getUser() {
    return this.user;
  }

  hasAuthority(authority: string) {
    if (!this.authenticated) {
      return false;
    }
    return this.hasAnyAuthority([authority]);
  }

  hasAnyAuthority(authorities: string[]) {
    if (!authorities || !this.user) {
      return false;
    }
    if (!this.authenticated || !this.user.roles) {
      return false;
    }

    for (let i = 0; i < authorities.length; i++) {
      if (this.user.roles.indexOf(authorities[i]) !== -1) {
        return true;
      }
    }

    return false;
  }

}
